import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';

import HistoryListPopUpView from './HistoryListPopUpView';
import {
  getDeviceDocumentsList,
  clearDeviceDocumentsList,
} from '../../actions/documents';
import { getAlerts } from '../../actions/AlertsActions';
import { setDeviceCommandValue } from '../../actions/device';
import { arrayDiffCounting } from './utils';

class HistoryListPopUp extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      startDate: moment().unix(),
      stopDate: moment().unix(),
      changed: false,
      historyDownloadInProgress: false,
      historyDownloadFailed: false,
      filesToDownload: 0,
      maxCheckNumber: 20,
      filesToDownloadValue: 2,
      newFiles: [],
    };
  }

  getNextAlertPage = () => {
    this.props.getAlerts({
      page: +this.props.alertsPaging.get('currentPage') + 1,
      search: this.props.serial,
    });
  };

  componentWillReceiveProps(newProps) {
    const oldTimestamps = this.props.deviceDocuments.map(document => {
      return document.get('timestamp');
    });

    const newTimestamps = newProps.deviceDocuments.map(document => {
      return document.get('timestamp');
    });

    const result = arrayDiffCounting(
      oldTimestamps.toArray(),
      newTimestamps.toArray(),
    );
    if (this.state.historyDownloadInProgress) {
      this.setState({
        newFiles: result.foundNew,
      });
    }
    if (result.count) {
      if (this.state.historyDownloadInProgress) {
        if (result.count > 1) {
          this.setState({
            filesToDownload: 0,
            historyDownloadFailed: false,
            historyDownloadInProgress: false,
          });
        } else {
          this.setState({
            filesToDownload: this.state.filesToDownload - result.count,
            historyDownloadFailed: false,
            historyDownloadInProgress: false,
          });
        }
      }
    }
  }

  getNextDocumentsPage = () => {

  }

  getDeviceDocumentsList = (serial) => {
    this.props.getDeviceDocumentsList(serial);
  }

  componentWillMount() {
    this.getDeviceDocumentsList(this.props.serial);
    this.props.getAlerts({ search: this.props.serial });
  }

  componentWillUnmount() {
    clearInterval(this.intervalId);
    this.props.clearDeviceDocumentsList();
  };

  onDownload = () => {
    const serial = this.props.serial;
    const startCommand = 'setHST';
    const stopCommand = 'setHET';
    const fifCommand = 'setFIF';
    this.props.setDeviceCommandValue(
      serial,
      startCommand,
      parseInt(this.state.startDate, 10),
    );
    this.props.setDeviceCommandValue(
      serial,
      stopCommand,
      parseInt(this.state.stopDate, 10),
    );
    this.setState({
      filesToDownloadValue: 2,
    });
    this.props.setDeviceCommandValue(serial, fifCommand, '0');
    this.startCheckingNewData(2);
  };

  onPulseMaskDownload = () => {
    const serial = this.props.serial;
    const startCommand = 'setFMA';
    this.props.setDeviceCommandValue(serial, startCommand, 1);
    this.setState({
      filesToDownloadValue: 1,
    });
    this.startCheckingNewData(1);
  };

  fromParentToChildCallback = (value, date) => {
    if (value === 'start') {
      this.setState({
        startDate: date,
        changed: true,
      });
    }
    if (value === 'stop') {
      this.setState({
        stopDate: date,
        changed: true,
      });
    }
  };

  checkForNewData = () => {
    if (this.state.maxCheckNumber === 0 || this.state.filesToDownload === 0) {
      clearInterval(this.intervalId);
      this.intervalId = null;
      this.setState({
        historyDownloadFailed: false,
        historyDownloadInProgress: false,
      });
      if (this.state.filesToDownload !== 0) {
        this.setState({
          historyDownloadFailed: true,
        });
      }
    }

    this.props.getDeviceDocumentsList(this.props.serial);
    this.setState({
      maxCheckNumber: this.state.maxCheckNumber - 1,
    });
  };

  startCheckingNewData = filesToDownload => {
    const interval = 1000 * 15;
    if (this.intervalId) {
      return;
    }
    this.checkForNewData();
    this.intervalId = window.setInterval(this.checkForNewData, interval);
    this.setState({
      historyDownloadInProgress: true,
      historyDownloadFailed: false,
      filesToDownload,
    });
  };

  render() {
    return (
      <HistoryListPopUpView
        deviceDocuments={this.props.deviceDocuments}
        deviceDocumentsPaging={this.props.deviceDocumentsPaging}
        serial={this.props.serial}
        deviceName={this.props.deviceName}
        deviceType={this.props.deviceType}
        devicePaging={this.props.devicePaging}
        onClose={this.props.onClose}
        onDownload={this.onDownload}
        onPulseMaskDownload={this.onPulseMaskDownload}
        fromParentToChildCallback={this.fromParentToChildCallback}
        alerts={this.props.alerts}
        alertsPaging={this.props.alertsPaging}
        getNextAlertPage={this.getNextAlertPage}
        getNextDocumentsPage={this.getNextDocumentsPage}
        getDeviceDocumentsList={this.getDeviceDocumentsList}
        historyDownloadInProgress={this.state.historyDownloadInProgress}
        historyDownloadFailed={this.state.historyDownloadFailed}
        filesToDownload={this.state.filesToDownload}
        filesToDownloadValue={this.state.filesToDownloadValue}
        newFilesDownloaded={this.state.newFiles}
      />
    );
  }
}

const mapState = state => ({
  deviceDocuments: state.deviceDocuments,
  deviceDocumentsPaging: state.deviceDocumentsPaging,
  alerts: state.alerts,
  alertsPaging: state.alertsPaging,
  devicePaging: state.devicePaging,
});

const mapDispatch = dispatch => {
  return {
    getDeviceDocumentsList: serial => dispatch(getDeviceDocumentsList(serial)),
    clearDeviceDocumentsList: () => dispatch(clearDeviceDocumentsList()),
    setDeviceCommandValue: (device, command, value) => 
      setDeviceCommandValue(device, command, value),
    getAlerts: (params, reqParams) => dispatch(getAlerts(params, reqParams)),
  };
};

HistoryListPopUp.propTypes = {
  serial: PropTypes.string.isRequired,
  deviceType: PropTypes.string.isRequired,
  deviceName: PropTypes.string.isRequired,
  getDeviceDocumentsList: PropTypes.func.isRequired,
  clearDeviceDocumentsList: PropTypes.func.isRequired,
  deviceDocuments: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  deviceDocumentsPaging: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  onClose: PropTypes.func.isRequired,
  setDeviceCommandValue: PropTypes.func.isRequired,
  alertsPaging: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  devicePaging: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
};

export default connect(mapState, mapDispatch)(HistoryListPopUp);



// WEBPACK FOOTER //
// ./src/components/HistoryListPopUp/HistoryListPopUp.js